app.service('productDetailSuccessorProduct', function (productCardConfig, modal) {
	let config;
	let $self;

	function init() {
		config = productCardConfig.getData();
		if(config.successorProductId) {
			$self = $('#successor-product-section');
			$self.addClass('loading');

			fetchSuccessorProduct().then(function (html) {
				renderSuccessorProduct(html);
				setEvents();
			}).fail(function () {
				modal.alert("[Nowszy Model] Błąd pobierania.");
			}).always(function () {
				return $self.removeClass('loading');
			});
		}
	}

	function fetchSuccessorProduct() {
		return $.ajax({
			url: '/successor-product.ltr',
			data: {
				successorProductId: config.successorProductId
			}
		});
	}

	function setEvents() {
		$('.product-photo a, .product-name a, .product-action a', '#successor-product').click(function() {
			UA.pageInteraction('Następnik', config.id);
		});
	}

	function renderSuccessorProduct(html) {
		$self.html(html);
	}

	return {
		init
	};
})